import OtherChannelNode from 'components/otherChannelNode/otherChannelNode.module';
import { BOT_MODE } from 'consts/enum';
import { createEngtChatHooks, getParamsFromUrl, syncMessagesAcrossTabs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { setSession } from 'js/session';
import { getCssFile, init } from '../../index';
import { appendPreviousMessages } from '../../js/conversation';
import { AppComponent } from './app.component';

const updatePageInformation = () => {
	const favicon = document.createElement('link');
	favicon.rel = 'shortcut icon';
	favicon.type = 'image/x-icon';
	favicon.href = ENGT_CHAT.get('config.icon_url');
	document.title = ENGT_CHAT.get('config.bot_name');
	document.head.appendChild(favicon);
};

export class App {
	constructor() {
		this.init();
	}

	async init() {
		const isRedirected = this.isRedirectFromChannel();
		if (isRedirected) {
			await this.renderSpecificNode(isRedirected);
		} else {
			await init(BOT_MODE.STANDALONE);
			await this.initComponents();
			appendPreviousMessages();
			setSession();
			updatePageInformation();
			this.afterStandaloneDOMLoad();
		}
	}

	async renderSpecificNode(nodeProps) {
		const node = await OtherChannelNode.initializeComponent(nodeProps);
		const brandedServerUrl = `${window.location.protocol}//${window.location.host}`;
		ENGT_CHAT.set('config.brandedServer', brandedServerUrl);
		await getCssFile();
		document.body.appendChild(node);
	}

	isRedirectFromChannel() {
		const botID = getParamsFromUrl('bot');
		const userID = getParamsFromUrl('userId');
		const nodeType = getParamsFromUrl('node_type');
		const platform = getParamsFromUrl('platform');
		const locale = getParamsFromUrl('locale');
		const key = getParamsFromUrl('key');
		const decodedKey = decodeURIComponent(key) ? atob(decodeURIComponent(key)) : '';
		if (botID && userID && nodeType) {
			return {
				bot: botID,
				user: userID,
				node: nodeType,
				platform,
				locale,
				key: decodedKey,
			};
		}
		return false;
	}

	afterStandaloneDOMLoad() {
		createEngtChatHooks();
		window.onENGTStandaloneLoad?.();
		window.addEventListener('storage', syncMessagesAcrossTabs);
	}

	async initComponents() {
		return AppComponent.init();
	}
}
